import React, { useState, useEffect } from 'react';
import { Copy, Check, X, Gift } from 'lucide-react';
import {
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';
import '../../styles/ShareModal.css';

const ShareModal = ({ link: referralLink, userProfile, onClose }) => {
    const [copied, setCopied] = useState(false);
    
    const shareText = `¡Únete a Lignums Group y empieza a participar! Usa mi código de referido: ${userProfile.username}`;

    const handleCopy = () => {
        // No hacer nada si no hay enlace para copiar.
        if (!referralLink) return;

        navigator.clipboard.writeText(referralLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    // Permite cerrar el modal con la tecla 'Escape'
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) onClose();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="referral-card dark-theme" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose}><X size={20} /></button>
                
                <div className="referral-header">
                    <Gift size={40} className="referral-icon" />
                    <h2>Invita y Gana</h2>
                    <p>Comparte tu enlace para que tus amigos se unan a tu red.</p>
                </div>

                <div className="referral-info">
                    <div className="referral-item">
                        <span>Tu código de referido</span>
                        <strong>{userProfile.username}</strong>
                    </div>
                    <div className="referral-item">
                        <span>Tu enlace de referido</span>
                        <div className="copy-container">
                            {/* El input se deshabilita si no hay enlace */}
                            <input type="text" value={referralLink} readOnly placeholder="Generando enlace..." />
                            <button onClick={handleCopy} disabled={!referralLink}>
                                {copied ? <Check size={18} /> : <Copy size={18} />}
                            </button>
                        </div>
                        {!referralLink && (
                            <small className="error-text" style={{ color: '#f87171', marginTop: '4px' }}>
                                Tu enlace no está disponible. Asegúrate de haber completado tu perfil.
                            </small>
                        )}
                    </div>
                </div>

                <div className="social-share-buttons">
                    {/* Los botones de compartir se deshabilitan si no hay enlace */}
                    <WhatsappShareButton url={referralLink} title={shareText} separator=":: " disabled={!referralLink}>
                        <div className="social-icon whatsapp"><i className="fab fa-whatsapp"></i></div>
                    </WhatsappShareButton>
                    <TelegramShareButton url={referralLink} title={shareText} disabled={!referralLink}>
                         <div className="social-icon telegram"><i className="fab fa-telegram-plane"></i></div>
                    </TelegramShareButton>
                    <FacebookShareButton url={referralLink} quote={shareText} disabled={!referralLink}>
                         <div className="social-icon facebook"><i className="fab fa-facebook-f"></i></div>
                    </FacebookShareButton>
                    <TwitterShareButton url={referralLink} title={shareText} disabled={!referralLink}>
                         <div className="social-icon x-twitter"><i className="fab fa-x-twitter"></i></div>
                    </TwitterShareButton>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;